const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/lists.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { withSiteTitle } from "@/lib/page-title";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/lists")({
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    return {
      meta: [{
        title: withSiteTitle(tMeta("myLists"))
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});